import { Component, OnInit, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { Company } from '@cyborg-monorepo/hunter/common'

import { UserService } from '../../../shared/services/user.service'

@Component({
  standalone: false,
  templateUrl: './cs.component.html',
  styleUrls: ['./cs.component.scss'],
})
export class CompanySettingsComponent implements OnInit {
  private userService = inject(UserService)

  public company$: Observable<Company | null>

  public ngOnInit(): void {
    // Load profile and extract company
    this.company$ = this.userService.profile$.pipe(
      map((profile) => profile?.company ?? null),
    )

    // Ensure profile is loaded
    this.userService.loadProfile().subscribe({
      error: (err) => console.error('Failed to load company info:', err),
    })
  }
}
